// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__11Xf9","rootSuccess":"CompleteLink_rootSuccess__2YJYT","rootFailure":"CompleteLink_rootFailure__2Smmp","isDisabled":"CompleteLink_isDisabled__1dVY5"};